import gql from 'graphql-tag';

const QUERY_OPTIMIZED_DATES = gql`
  query OptimizeDates(
    $listingId: String!
    $moveIn: String!
    $moveOut: String!
  ) {
    calculateOptimizedDatesWithSavings(
      listingId: $listingId
      moveIn: $moveIn
      moveOut: $moveOut
    ) {
      moveIn
      moveOut
      savings {
        timeSaving
        moneySaving
      }
    }
  }
`;

export const getOptimizedDates =
  client =>
  async ({ listingId, moveIn, moveOut }) => {
    const { data } = await client.query({
      query: QUERY_OPTIMIZED_DATES,
      fetchPolicy: 'network-only',
      variables: {
        listingId,
        moveIn,
        moveOut
      }
    });
    return data?.calculateOptimizedDatesWithSavings;
  };

export default getOptimizedDates;
